import script from "./BodyTopMainUserCases.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyTopMainUserCases.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodyTopMainUserCases.vue?vue&type=style&index=0&id=7647130f&module=userCaseStyle&lang=css"
cssModules["userCaseStyle"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QImg from 'quasar/src/components/img/QImg.js';import TouchSwipe from 'quasar/src/directives/TouchSwipe.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QImg});qInstall(script, 'directives', {TouchSwipe});
